module.exports = __webpack_public_path__ + "media/26.42bf05ec.wav";